import React, { useState } from 'react';
import { AmityUiKitProvider } from '@frn/amityco-ui-kit-open-source';
import { connect } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { actions as userActions } from 'modules/user';
import GeneralModal from 'components/GeneralModal';
import Profile from 'routes/User/Profile/containers';

const SocialPlusProvider = ({
  user,
  socialPlusApiKey,
  productSlug,
  retrieveSocialPlusToken,
  insecure,
  children,
  configs = {}
}) => {
  const [adminProfileUserId, setAdminProfileUserId] = useState(null);

  console.log('SocialPlusProvider', user, socialPlusApiKey, productSlug);
  const { userId, firstName, lastName } = user;
  const userIdString = userId.toString();
  const displayName = `${firstName} ${lastName.charAt(0).toUpperCase()}`;

  const isAdminOrCSUser = (() => {
    try {
      return ['admin', 'cs'].includes(jwtDecode(user.authToken)?.role);
    } catch (e) {
      return false;
    }
  })();

  const getAuthToken = async () => {
    const token = await retrieveSocialPlusToken(productSlug);
    return token;
  };

  return (
    <AmityUiKitProvider
      key={socialPlusApiKey}
      apiKey={socialPlusApiKey}
      userId={userIdString}
      displayName={displayName}
      apiRegion={'US'}
      {...(!insecure ? { getAuthToken } : {})}
      pageBehavior={
        isAdminOrCSUser
          ? {
              AmityUserProfileHeaderComponentBehavior: {
                onAdminAction: setAdminProfileUserId
              }
            }
          : undefined
      }
      theme="light"
      configs={{
        excludes: ['community_profile_page/community_header/community_category', '*/*/clipsfeed_button'],
        ...configs,
        preferred_theme: 'light'
      }}
    >
      {children}
      {adminProfileUserId && (
        <GeneralModal
          isOpen
          toggle={() => setAdminProfileUserId(null)}
          component={() => <Profile publicProfileUserId={adminProfileUserId} showSummary />}
        />
      )}
    </AmityUiKitProvider>
  );
};

// Redux Connect
const mapStateToProps = state => ({
  user: state.user
});

const mapDispatchToProps = dispatch => ({
  retrieveSocialPlusToken: productSlug => dispatch(userActions.retrieveSocialPlusToken(productSlug))
});

export default connect(mapStateToProps, mapDispatchToProps)(SocialPlusProvider);
